var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailSubtracted = function SvgEmailSubtracted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.55 10.374a6.177 6.177 0 1 1 0 12.354 6.177 6.177 0 0 1 0-12.354m0 1.951a4.226 4.226 0 1 0 .001 8.452 4.226 4.226 0 0 0 0-8.452m2.601 3.251a.976.976 0 0 1 0 1.951h-5.2a.976.976 0 0 1 0-1.95zm0-14.305a2.27 2.27 0 0 1 1.735.805l.031.038.014.016.017.025c.3.385.479.868.479 1.393v5.851a.975.975 0 0 1-1.95 0V4.48l-5.785 4.449a3.84 3.84 0 0 1-4.685 0L3.223 4.479v9.471c0 .18.145.325.325.325h5.201a.975.975 0 0 1 0 1.95H3.548A2.276 2.276 0 0 1 1.27 13.95V3.548a2.26 2.26 0 0 1 .515-1.442l.02-.023.038-.04a2.27 2.27 0 0 1 1.704-.772zm-8.956 6.11.131.093c.667.429 1.54.398 2.178-.092l5.406-4.16H4.79z"
  })));
};
export default SvgEmailSubtracted;